import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import ROUTES from '../../routes';
import useStyles from './styles';
import useConnect from './hooks';
import messages from './messages';

const PrivacyPolicy = () => {
  const classes = useStyles();
  const { token } = useConnect();
  return (
    <Grid className={classes.padding}>
      <FormattedMessage {...messages.privacy_policy_label} />{' '}
      <Link
        to={{ pathname: `${ROUTES.LEGISLATION.path}`, search: `?token=${token}&pdf=user_data_eligibility` }}
        target="_blank"
      >
        <FormattedMessage {...messages.privacy_policy_link} />
      </Link>
    </Grid>
  );
};

export default PrivacyPolicy;
